import { AppConfig } from "@/script/core/base/AppConfig";
import { JsonResult } from "@/script/core/base/JsonResult";
import { BaseService } from "@/script/core/service/BaseService"
import store from "@/store";
import axios from "axios";

export class NodeService extends BaseService {
    public loadCameraTree(id: number): Promise<any> {
        return super.get("/api/rec/node/camera-tree/query", { id });
    }

    public loadCruisesByNode(id: number): Promise<any> {
        return super.get("/api/rec/node/cruise/query", { id });
    }


    public cruiseStart(nodeId: number): Promise<any> {
        return this.postCruise("/app-cruise/api/cruise-robot/start?nodeId=" + nodeId, {})           
    }

    public cruiseStop(nodeId: number): Promise<any> {
        return this.postCruise("./app-cruise/api/cruise-robot/stop?nodeId=" + nodeId, {});
    }

    public cruisePause(nodeId: number): Promise<any> {
        return this.postCruise("./app-cruise/api/cruise-robot/pause?nodeId=" + nodeId, {});
    }

    public cruiseContinue(nodeId: number): Promise<any> {
        return this.postCruise("./app-cruise/api/cruise-robot/continue?nodeId=" + nodeId, {});
    }

    public postCruise(path: string, data: any): Promise<any> {
        const promise = new Promise<any>(function (resolve, reject) {
            try {
                const url = new URL(AppConfig.Config.ServerUrl);
                axios.create({ baseURL: "http://" + url.hostname })
                    .post(path, data, { headers: { Authorization: store.getters.loginToken } })
                    .then(function (response) {
                        if (response.status === 200) {
                            const resultJson = response.data as JsonResult;
                            if (resultJson.success) {
                                resolve(resultJson);
                            } else {
                                reject(new Error(resultJson.code + ":" + resultJson.message));
                            }
                        } else {
                            reject(new Error(response.statusText));
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
        return promise;
    }
}
